import PropTypes from "prop-types";
import { Box, SvgIcon, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

export const NoResultText = ({ query }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ mt: 4, textAlign: "center", px: 2 }}>
      <SvgIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }}>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </SvgIcon>
      <Typography variant="subtitle1" color="text.secondary">
        {t("search.noResults", { query })}
      </Typography>
      <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
        {t("search.noResultsHint")}
      </Typography>
    </Box>
  );
};

NoResultText.propTypes = {
  query: PropTypes.string.isRequired,
};
